import { FC, useMemo } from 'react';
import { generalHthHelper } from '@monorepo/helpers';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { houseToHouseServices } from 'src/services';
import { typeHTHTerritory, typeHTHFace } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetConfig } from 'src/custom-hooks';

type propsType = {
    currentFace: typeHTHFace;
    hthTerritory: typeHTHTerritory;
};

export const HTHFaceDeleteButton: FC<propsType> = ({ currentFace, hthTerritory }) => {
    const config = useGetConfig();
    const dispatch = useDispatch();

    const openConfirmModalHTHDeleteFaceHandler = (): void => {
        if (!currentFace || !hthTerritory || !hthTerritory.faces) {
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: "¿Eliminar cara?",
            message: `Se va a eliminar esta CARA ${currentFace.street} de MANZANA ${generalHthHelper.MaskTheBlock(currentFace.block, config.isUsingLettersForBlocks)}. Esta acción no tiene vuelta atrás.`,
            execution: deleteHTHFaceHandler
        }));
    }

    const deleteHTHFaceHandler = async (): Promise<void> => {
        if (!currentFace || !hthTerritory || !hthTerritory.faces) {
            return;
        }
        dispatch(showLoadingModalReducer());
        const response = await houseToHouseServices.DeletePolygonFace(hthTerritory.territoryNumber, currentFace.block, currentFace.face, currentFace.id);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
        }
    }

    const isDisabled: boolean = useMemo(() => {
        return !!currentFace.buildings?.length || !!currentFace.doNotCalls?.length || !!currentFace.observations?.length;
    }, [currentFace.buildings?.length, currentFace.doNotCalls?.length, currentFace.observations?.length]);
    
    return (
        <button className={'btn btn-general-red btn-size12 d-block mx-auto py-3'}
            style={{ marginTop: '100px', width: '90%' }}
            onClick={() => openConfirmModalHTHDeleteFaceHandler()}
            disabled={isDisabled}
        >
            ELIMINAR CARA
        </button>
    );
}
